import { Translate } from 'react-redux-i18n'
import { FORMAT, formatDateTime } from '../../../helpers/datetime'
import { formatText } from '../../../helpers/value'
import { TITLE_TABLE_FOLLOWING_LIST } from '../constant'
import { CustomTdActionFollowingList } from './CustomTdActionFollowingList'
import { CustomTdStatus } from './CustomTdStatus'
import { CustomTdTitleFollowingList } from './CustomTdTitleFollowingList'
import { CustomThTitleFollowingList } from './CustomThTitleFollowingList'
import { CustomThTooltip } from './CustomThTooltip'

export const getSchemaTableFollowingList = () =>
  TITLE_TABLE_FOLLOWING_LIST.map((item, index) => {
    const result = {
      title: <Translate value={item.label} />,
      colId: item.key,
      thStyle: {
        textAlign: 'left',
        textTransform: 'capitalize',
      },
      tdStyle: {
        textAlign: 'left',
      },
    }
    if (index === 0) {
      return {
        title: <CustomThTitleFollowingList item={item.label} />,
        colId: item.key,
        thStyle: {
          textAlign: 'left',
          width: '100%',
          textTransform: 'capitalize',
        },
        tdStyle: {
          textAlign: 'left',
          padding: 0,
        },
        render: (val, { rowId }) => {
          return <CustomTdTitleFollowingList item={val} rowId={rowId} />
        },
      }
    }
    if (index === 2) {
      return {
        ...result,
        sortable: true,
        render: (val, { rowId }) => {
          return <CustomTdStatus val={val} />
        },
      }
    }
    if (index === 3) {
      return {
        ...result,
        sortable: true,
        title: <CustomThTooltip value={item.label} />,
        render: (val, { locale }) => {
          return formatDateTime(val, FORMAT.DATE, locale)
        },
      }
    }
    if (index === 4) {
      return {
        ...result,
        render: (val, { rowId }) => {
          return <CustomTdActionFollowingList rowId={rowId} />
        },
      }
    }
    return {
      ...result,
      render: (val) => {
        return formatText(val)
      },
    }
  })
